import { forwardRef } from 'react';

const variants = {
  primary: 'bg-game-primary hover:bg-game-teal-dark text-white shadow-lg shadow-game-primary/20',
  secondary: 'bg-game-surface hover:bg-game-secondary text-game-text border border-[#2a2d31]',
  accent: 'bg-game-accent hover:bg-[#d9b814] text-game-bg font-semibold',
  danger: 'bg-game-error hover:bg-red-700 text-white',
  success: 'bg-game-primary hover:bg-game-teal-dark text-white',
  ghost: 'bg-transparent hover:bg-game-surface text-game-text',
};

const sizes = {
  sm: 'px-4 py-1.5 text-sm',
  md: 'px-6 py-2.5 text-base',
  lg: 'px-8 py-3.5 text-lg',
};

const Button = forwardRef(({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  className = '',
  pill = true,
  ...props
}, ref) => {
  return (
    <button
      ref={ref}
      disabled={disabled}
      className={`
        ${variants[variant]}
        ${sizes[size]}
        ${pill ? 'rounded-pill' : 'rounded-lg'}
        font-semibold
        transition-all duration-200
        disabled:opacity-50 disabled:cursor-not-allowed
        focus:outline-none focus:ring-2 focus:ring-game-primary focus:ring-offset-2 focus:ring-offset-game-bg
        inline-flex items-center justify-center
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;
